<template>
	<v-container fluid>
		<br>
		<v-flex xs12 sm6 offset-sm3>
			
			<v-form ref="form" lazy-validation>
				<v-card>
					<v-card-title>
						<h4 class="primary--text">Registration</h4>
					</v-card-title>
					<v-card-text>
						<br>
						<v-text-field v-model="email" name="email" label="Email" type="email" :rules="[rules.required, rules.email]" required></v-text-field>
						<v-text-field v-model="password" name="password" min="8" :append-icon="e1 ? 'visibility_off' : 'visibility'" 
						:rules="[
							(v) => !!password || 'This field is required',
							(v) => !!password && password.length >= 8 || 'Password must be less than 8 characters'
						]"
						:append-icon-cb="(v) => (e1 = !e1)" :type="e1 ? 'password' : 'text'" hint="At least 8 characters" ref="password" label="Password" required></v-text-field>
						<v-text-field v-model="firstName" name="firstName" label="firstName" type="text" ref="firstName" :rules="[(v) => !!firstName || 'This field is required']" required></v-text-field>
						<v-text-field v-model="lastName" name="lastName" label="lastName" type="text" ref="lastName" :rules="[(v) => !!lastName || 'This field is required']" required></v-text-field>
						<v-text-field v-model="phone" name="phone" label="Phone No" :mask="mask"></v-text-field>
						<v-text-field v-model="address" name="address" type="text" label="Address" ref="address" :rules="[(v) => !!address || 'This field is required']" required multi-line></v-text-field>
					</v-card-text>
					<v-card-actions>
						<v-btn flat color="blue" @click.prevent="resetAll">Reset</v-btn>
						<v-spacer></v-spacer>
						<v-btn flat color="green" @click.native.prevent="loginWithEmailLocal">Sign Up</v-btn>
						<!-- :disabled="!formIsValid" -->
					</v-card-actions>
				</v-card>
			</v-form>
		</v-flex>
	</v-container>
</template>


<script>
	import {
		auth,
		ref,
		firebase
	} from '../config/firebase'
	
	export default {
		data() {
			const defaultForm = Object.freeze({
				firstName: '',
				email: '',
				password: '',
				lastName: '',
				phone: '',
				address: ''
			})
			return {
				form: Object.assign({}, defaultForm),
				email: '',
				password: '',
				firstName: '',
				lastName: '',
				phone: '',
				isMember: true,
				isOrdered: false,
				mask: 'phone',
				address: '',
				rules: {
					required: (value) => !!value || 'Required.',
					email: (value) => {
						const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						return pattern.test(value) || 'Invalid e-mail.'
					}
				},
				e1: true,
				defaultForm
			}
		},
		computed: {
			user() {
	
				return this.$store.getters.user;
			},
			validate() {
				return this.$refs.form.validate();
			},
			formIsValid() {
				return (
					this.form.firstName &&
					this.form.lastName &&
					this.form.address &&
					this.form.email &&
					this.form.password
				)
			}
		},
		methods: {
			resetAll() {
				this.$refs.form.reset()
			},
			loginWithEmailLocal() {
				var vm = this;
				if (this.firstName && this.lastName && this.address !== null) {
					this.$store.dispatch('signUp', {
							email: this.email,
							password: this.password
						})
						.then(() => {
							ref.child('users').child(this.user).set({
								firstName: vm.firstName,
								lastName: vm.lastName,
								phone: vm.phone,
								isMember: vm.isMember,
								isOrdered: vm.isOrdered,
								address: vm.address
							})
							alert('Successfuly register')
							vm.$router.push({
								name: 'HomePage'
							})
						}).catch(error => {
							alert(error)
						})
				} else {
					alert('Please fulfil the form')
				}
			}
		}
	}
</script>


<style>
	
</style>



// WEBPACK FOOTER //
// src/components/Register.vue